import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteRetailerRetailerTagMutationVariables = Types.Exact<{
  retailerId: Types.Scalars['Int'];
  retailerTagId: Types.Scalars['Int'];
}>;


export type DeleteRetailerRetailerTagMutation = { __typename?: 'Mutation', deleteRetailerRetailerTag?: { __typename?: 'retailersRetailerRetailerTag', retailer_id: number, retailer_tag_id: number } | null };


export const DeleteRetailerRetailerTagDocument = gql`
    mutation DeleteRetailerRetailerTag($retailerId: Int!, $retailerTagId: Int!) {
  deleteRetailerRetailerTag: retailersDeleteRetailerRetailerTag(
    retailer_id: $retailerId
    retailer_tag_id: $retailerTagId
  ) {
    retailer_id
    retailer_tag_id
  }
}
    `;
export type DeleteRetailerRetailerTagMutationFn = Apollo.MutationFunction<DeleteRetailerRetailerTagMutation, DeleteRetailerRetailerTagMutationVariables>;

/**
 * __useDeleteRetailerRetailerTagMutation__
 *
 * To run a mutation, you first call `useDeleteRetailerRetailerTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRetailerRetailerTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRetailerRetailerTagMutation, { data, loading, error }] = useDeleteRetailerRetailerTagMutation({
 *   variables: {
 *      retailerId: // value for 'retailerId'
 *      retailerTagId: // value for 'retailerTagId'
 *   },
 * });
 */
export function useDeleteRetailerRetailerTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRetailerRetailerTagMutation, DeleteRetailerRetailerTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRetailerRetailerTagMutation, DeleteRetailerRetailerTagMutationVariables>(DeleteRetailerRetailerTagDocument, options);
      }
export type DeleteRetailerRetailerTagMutationHookResult = ReturnType<typeof useDeleteRetailerRetailerTagMutation>;
export type DeleteRetailerRetailerTagMutationResult = Apollo.MutationResult<DeleteRetailerRetailerTagMutation>;
export type DeleteRetailerRetailerTagMutationOptions = Apollo.BaseMutationOptions<DeleteRetailerRetailerTagMutation, DeleteRetailerRetailerTagMutationVariables>;